import type { DropDownItem } from '../Combobox/';

export const countries: DropDownItem[] = [
  { value: '+93', label: 'Afghanistan (افغانستان)', data: { iso2: 'af' } },
  { value: '+355', label: 'Albania (Shqipëria)', data: { iso2: 'al' } },
  { value: '+213', label: 'Algeria (الجزائر)', data: { iso2: 'dz' } },
  { value: '+376', label: 'Andorra (AD)', data: { iso2: 'ad' } },
  { value: '+244', label: 'Angola (AO)', data: { iso2: 'ao' } },
  { value: '+54', label: 'Argentina (AR)', data: { iso2: 'ar' } },
  { value: '+374', label: 'Armenia (Հայաստան)', data: { iso2: 'am' } },
  { value: '+61', label: 'Australia (AU)', data: { iso2: 'au' } },
  { value: '+43', label: 'Austria (Österreich)', data: { iso2: 'at' } },
  { value: '+994', label: 'Azerbaijan (Azərbaycan)', data: { iso2: 'az' } },
  { value: '+1-242', label: 'Bahamas (BS)', data: { iso2: 'bs' } },
  { value: '+973', label: 'Bahrain (البحرين)', data: { iso2: 'bh' } },
  { value: '+880', label: 'Bangladesh (বাংলাদেশ)', data: { iso2: 'bd' } },
  { value: '+375', label: 'Belarus (Беларусь)', data: { iso2: 'by' } },
  { value: '+32', label: 'Belgium (België)', data: { iso2: 'be' } },
  { value: '+501', label: 'Belize (BZ)', data: { iso2: 'bz' } },
  { value: '+229', label: 'Benin (Bénin)', data: { iso2: 'bj' } },
  { value: '+975', label: 'Bhutan (འབྲུག)', data: { iso2: 'bt' } },
  { value: '+591', label: 'Bolivia (BO)', data: { iso2: 'bo' } },
  {
    value: '+387',
    label: 'Bosnia and Herzegovina (Bosna i Hercegovina)',
    data: { iso2: 'ba' },
  },
  { value: '+267', label: 'Botswana (BW)', data: { iso2: 'bw' } },
  { value: '+55', label: 'Brazil (Brasil)', data: { iso2: 'br' } },
  { value: '+673', label: 'Brunei (BN)', data: { iso2: 'bn' } },
  { value: '+359', label: 'Bulgaria (България)', data: { iso2: 'bg' } },
  { value: '+226', label: 'Burkina Faso (BF)', data: { iso2: 'bf' } },
  { value: '+257', label: 'Burundi (BI)', data: { iso2: 'bi' } },
  { value: '+855', label: 'Cambodia (កម្ពុជា)', data: { iso2: 'kh' } },
  { value: '+237', label: 'Cameroon (Cameroun)', data: { iso2: 'cm' } },
  { value: '+1', label: 'Canada (CA)', data: { iso2: 'ca' } },
  { value: '+56', label: 'Chile (CL)', data: { iso2: 'cl' } },
  { value: '+86', label: 'China (中国)', data: { iso2: 'cn' } },
  { value: '+57', label: 'Colombia (CO)', data: { iso2: 'co' } },
  { value: '+506', label: 'Costa Rica (Costa Rica)', data: { iso2: 'cr' } },
  { value: '+385', label: 'Croatia (Hrvatska)', data: { iso2: 'hr' } },
  { value: '+53', label: 'Cuba (CU)', data: { iso2: 'cu' } },
  { value: '+357', label: 'Cyprus (Κύπρος)', data: { iso2: 'cy' } },
  { value: '+420', label: 'Czech Republic (Česko)', data: { iso2: 'cz' } },
  { value: '+45', label: 'Denmark (Danmark)', data: { iso2: 'dk' } },
  {
    value: '+1-809',
    label: 'Dominican Republic (República Dominicana)',
    data: { iso2: 'do' },
  },
  { value: '+593', label: 'Ecuador (EC)', data: { iso2: 'ec' } },
  { value: '+20', label: 'Egypt (مصر)', data: { iso2: 'eg' } },
  { value: '+503', label: 'El Salvador (SV)', data: { iso2: 'sv' } },
  { value: '+372', label: 'Estonia (Eesti)', data: { iso2: 'ee' } },
  { value: '+251', label: 'Ethiopia (ኢትዮጵያ)', data: { iso2: 'et' } },
  { value: '+358', label: 'Finland (Suomi)', data: { iso2: 'fi' } },
  { value: '+33', label: 'France (FR)', data: { iso2: 'fr' } },
  { value: '+49', label: 'Germany (Deutschland)', data: { iso2: 'de' } },
  { value: '+233', label: 'Ghana (GH)', data: { iso2: 'gh' } },
  { value: '+30', label: 'Greece (Ελλάδα)', data: { iso2: 'gr' } },
  { value: '+502', label: 'Guatemala (GT)', data: { iso2: 'gt' } },
  { value: '+504', label: 'Honduras (HN)', data: { iso2: 'hn' } },
  { value: '+852', label: 'Hong Kong (香港)', data: { iso2: 'hk' } },
  { value: '+36', label: 'Hungary (Magyarország)', data: { iso2: 'hu' } },
  { value: '+354', label: 'Iceland (Ísland)', data: { iso2: 'is' } },
  { value: '+91', label: 'India (भारत)', data: { iso2: 'in' } },
  { value: '+62', label: 'Indonesia (ID)', data: { iso2: 'id' } },
  { value: '+98', label: 'Iran (ایران)', data: { iso2: 'ir' } },
  { value: '+964', label: 'Iraq (العراق)', data: { iso2: 'iq' } },
  { value: '+353', label: 'Ireland (Éire)', data: { iso2: 'ie' } },
  { value: '+972', label: 'Israel (ישראל)', data: { iso2: 'il' } },
  { value: '+39', label: 'Italy (Italia)', data: { iso2: 'it' } },
  { value: '+1-876', label: 'Jamaica (JM)', data: { iso2: 'jm' } },
  { value: '+81', label: 'Japan (日本)', data: { iso2: 'jp' } },
  { value: '+962', label: 'Jordan (الأردن)', data: { iso2: 'jo' } },
  { value: '+254', label: 'Kenya (KE)', data: { iso2: 'ke' } },
  { value: '+965', label: 'Kuwait (الكويت)', data: { iso2: 'kw' } },
  { value: '+371', label: 'Latvia (Latvija)', data: { iso2: 'lv' } },
  { value: '+961', label: 'Lebanon (لبنان)', data: { iso2: 'lb' } },
  { value: '+370', label: 'Lithuania (Lietuva)', data: { iso2: 'lt' } },
  { value: '+352', label: 'Luxembourg (Lëtzebuerg)', data: { iso2: 'lu' } },
  { value: '+60', label: 'Malaysia (MY)', data: { iso2: 'my' } },
  { value: '+52', label: 'Mexico (México)', data: { iso2: 'mx' } },
  { value: '+212', label: 'Morocco (المغرب)', data: { iso2: 'ma' } },
  { value: '+31', label: 'Netherlands (Nederland)', data: { iso2: 'nl' } },
  { value: '+64', label: 'New Zealand (Aotearoa)', data: { iso2: 'nz' } },
  { value: '+234', label: 'Nigeria (NG)', data: { iso2: 'ng' } },
  { value: '+47', label: 'Norway (Norge)', data: { iso2: 'no' } },
  { value: '+92', label: 'Pakistan (پاکستان)', data: { iso2: 'pk' } },
  { value: '+507', label: 'Panama (Panamá)', data: { iso2: 'pa' } },
  { value: '+595', label: 'Paraguay (Paraguay)', data: { iso2: 'py' } },
  { value: '+51', label: 'Peru (Perú)', data: { iso2: 'pe' } },
  { value: '+63', label: 'Philippines (Pilipinas)', data: { iso2: 'ph' } },
  { value: '+48', label: 'Poland (Polska)', data: { iso2: 'pl' } },
  { value: '+351', label: 'Portugal (PT)', data: { iso2: 'pt' } },
  { value: '+974', label: 'Qatar (قطر)', data: { iso2: 'qa' } },
  { value: '+40', label: 'Romania (România)', data: { iso2: 'ro' } },
  { value: '+7', label: 'Russia (Россия)', data: { iso2: 'ru' } },
  { value: '+966', label: 'Saudi Arabia (السعودية)', data: { iso2: 'sa' } },
  { value: '+381', label: 'Serbia (Србија)', data: { iso2: 'rs' } },
  { value: '+65', label: 'Singapore (SG)', data: { iso2: 'sg' } },
  { value: '+421', label: 'Slovakia (Slovensko)', data: { iso2: 'sk' } },
  { value: '+386', label: 'Slovenia (Slovenija)', data: { iso2: 'si' } },
  { value: '+27', label: 'South Africa (ZA)', data: { iso2: 'za' } },
  { value: '+82', label: 'South Korea (한국)', data: { iso2: 'kr' } },
  { value: '+34', label: 'Spain (España)', data: { iso2: 'es' } },
  { value: '+94', label: 'Sri Lanka (ශ්‍රී ලංකාව)', data: { iso2: 'lk' } },
  { value: '+46', label: 'Sweden (Sverige)', data: { iso2: 'se' } },
  { value: '+41', label: 'Switzerland (Schweiz)', data: { iso2: 'ch' } },
  { value: '+66', label: 'Thailand (ประเทศไทย)', data: { iso2: 'th' } },
  { value: '+90', label: 'Turkey (Türkiye)', data: { iso2: 'tr' } },
  { value: '+380', label: 'Ukraine (Україна)', data: { iso2: 'ua' } },
  {
    value: '+971',
    label: 'United Arab Emirates (الإمارات)',
    data: { iso2: 'ae' },
  },
  { value: '+44', label: 'United Kingdom (GB)', data: { iso2: 'gb' } },
  { value: '+1', label: 'United States (USA)', data: { iso2: 'us' } },
  { value: '+598', label: 'Uruguay (UY)', data: { iso2: 'uy' } },
  { value: '+58', label: 'Venezuela (VE)', data: { iso2: 've' } },
  { value: '+84', label: 'Vietnam (Việt Nam)', data: { iso2: 'vn' } },
  { value: '+260', label: 'Zambia (ZM)', data: { iso2: 'zm' } },
  { value: '+263', label: 'Zimbabwe (ZW)', data: { iso2: 'zw' } },
];
